import { render, staticRenderFns } from "./IntegralDialog.vue?vue&type=template&id=97f15dd8&scoped=true"
import script from "./IntegralDialog.vue?vue&type=script&lang=js"
export * from "./IntegralDialog.vue?vue&type=script&lang=js"
import style0 from "./IntegralDialog.vue?vue&type=style&index=0&id=97f15dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f15dd8",
  null
  
)

export default component.exports